
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.4 0H2.6v24h18.8V4l-4-4z","fill":"#E8E8E8"}}),_c('path',{attrs:{"d":"M16.686 4.885h-9.49v9.49h9.49v-9.49z","fill":"#38A3FF"}}),_c('path',{attrs:{"d":"M11.94 13.23a3.6 3.6 0 100-7.201 3.6 3.6 0 000 7.201z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.434 11.328c-.329.212-.597.066-.597-.324V8.256c0-.391.268-.537.597-.325l2.028 1.313c.328.212.328.56 0 .772l-2.028 1.312zM18.02 2H2.6V0h14.8l.62 2z","fill":"#38A3FF"}}),_c('path',{attrs:{"d":"M8.195 21.68l-.777-2.736h-.023c.036.466.054.828.054 1.086v1.65H6.54v-3.798h1.366l.793 2.696h.02l.777-2.696h1.37v3.798h-.944v-1.665c0-.087.002-.183.004-.289.003-.105.015-.364.035-.776h-.023l-.766 2.73h-.977zm6.245-2.59c0 .424-.125.751-.375.983-.25.23-.606.346-1.067.346h-.288v1.26h-1.026v-3.798h1.314c.48 0 .84.105 1.08.315.241.21.362.507.362.893zm-1.73.493h.187a.51.51 0 00.367-.13.471.471 0 00.137-.358c0-.257-.142-.385-.426-.385h-.265v.873zm4.962 1.361h-.419v.735H16.24v-.735h-1.514v-.753l1.579-2.31h.948v2.297h.419v.766zm-1.432-.766v-.442a8.195 8.195 0 01.024-.558h-.029a2.758 2.758 0 01-.2.374l-.42.626h.625z","fill":"#A4A9AD"}}),_c('path',{attrs:{"d":"M17.4 4h4l-4-4v4z","fill":"#D1D3D3"}})])
          )
        }
      }
    